import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    results: null,
    pagination: null,
    dataDictionary: null
  },
  mutations: {
    SET_COST_CENTERS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
      state.dataDictionary = payload.dataDictionary;
    }
  },
  actions: {
    async loadCostCenters({ commit }, params) {
      try {
        params.getDictionary = true;
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get("/admin/cost-centers", {
          params: params
        });
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_COST_CENTERS", res.data);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async saveCostCenter({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/admin/cost-centers/${params.id}`,
          {
            name: params.name,
            defaultProductId: params.defaultProductId,
            ERPCode: params.ERPCode
          }
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async addCostCenter({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/admin/cost-centers", {
          name: params.name,
          defaultProductId: params.defaultProductId,
          ERPCode: params.ERPCode
        });
        if (res.status != 201) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async deleteCostCenter({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(
          `/admin/cost-centers/${id}`
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  },
  getters: {
    products: state => {
      const products = {
        results: state.results,
        pagination: state.pagination
      };
      return products;
    }
  }
};
